import CircularProgress from 'material-ui/CircularProgress';
import PropTypes from 'prop-types';
import r from 'render-dom';
import styled from 'styled-components';

const propTypes = {
    style: PropTypes.object,
};

const Container = styled.div`
    padding: 70px;
    text-align: center;
`;

export default function Spinner({ children, className = '', color, size = 40, style }) {
    return (
        r(Container, { className, style }, [
            r(CircularProgress, { color, size, stroke: '#fff' }),
            children,
        ])
    );
}

Spinner.propTypes = propTypes;
